var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBannerGridDataAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 424,
    viewBox: "0 0 1512 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_105)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -300,
    y: -225,
    width: 1956,
    height: 1440
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788.16 316.828C788.16 464.088 690.795 583.465 570.69 583.465C450.584 583.465 -299.822 66.9679 -299.822 -80.292C-299.822 -227.552 778.366 -24.8213 898.471 -24.8213C1018.58 -24.8213 788.16 169.568 788.16 316.828Z",
    fill: "url(#paint0_linear_8_105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.32 317.232C1443.39 609.92 1293.69 462.832 1572.03 455.422C1615.7 463.833 1689.82 464.233 1637.01 398.542C1571 316.427 1592.27 258.429 1509.77 168.965C1427.27 79.5012 1377.02 -11.3926 1252.47 -153.683C1127.91 -295.973 1118.33 -178.679 977.908 -189.798C837.488 -200.917 901.534 -183.26 707.79 23.1974C514.046 229.654 795.255 24.5432 1119.32 317.232Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.32 447.232C1443.38 739.921 1293.69 592.833 1572.03 585.422C1615.69 593.834 1689.82 594.234 1637.01 528.542C1570.99 446.428 1592.27 388.429 1509.77 298.965C1427.26 209.501 1377.02 118.608 1252.46 -23.6825C1127.91 -165.973 1118.33 -48.6787 977.906 -59.7979C837.486 -70.9169 901.532 -53.2595 707.788 153.198C514.044 359.655 795.253 154.543 1119.32 447.232Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M813.374 777.614C379.694 828.672 588.97 812.913 411.212 1027.23C376.122 1054.55 326.997 1110.06 411.212 1113.59C516.48 1118 546.107 1172.21 667.764 1169.06C789.421 1165.91 890.907 1187.97 1080.01 1187.97C1269.12 1187.97 1187.17 1103.5 1288.03 1005.17C1388.88 906.835 1333.41 943.395 1305.68 661.629C1277.94 379.864 1247.05 726.555 813.374 777.614Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M781.624 607.852C781.624 755.112 684.259 874.49 564.154 874.49C444.048 874.49 -225.043 840.165 -225.043 692.905C-225.043 545.645 -175.585 196.82 -55.4791 196.82C64.6264 196.82 781.624 460.593 781.624 607.852Z",
    fill: "url(#paint1_radial_8_105)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_105)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -2.29687,
    y1: 299.809,
    x2: 1509.28,
    y2: 299.809,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.29687,
    y1: 138.439,
    x2: 1509.28,
    y2: 138.439,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.29687,
    y1: 219.124,
    x2: 1509.28,
    y2: 219.124,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.29687,
    y1: 380.492,
    x2: 1509.28,
    y2: 380.492,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.29687,
    y1: 57.7541,
    x2: 1509.28,
    y2: 57.7541,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.9784,
    y1: -51.2955,
    x2: 44.9783,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690.459,
    y1: -51.2955,
    x2: 690.459,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.719,
    y1: -51.2957,
    x2: 367.719,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1013.2,
    y1: -51.2955,
    x2: 1013.2,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1335.94,
    y1: -51.2955,
    x2: 1335.94,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.349,
    y1: -51.2955,
    x2: 206.348,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 851.825,
    y1: -51.2955,
    x2: 851.825,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.089,
    y1: -51.2955,
    x2: 529.089,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1174.57,
    y1: -51.2957,
    x2: 1174.57,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1497.31,
    y1: -51.2955,
    x2: 1497.31,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.666,
    y1: -51.2955,
    x2: 125.666,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 771.142,
    y1: -51.2957,
    x2: 771.142,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.402,
    y1: -51.2955,
    x2: 448.402,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1093.88,
    y1: -51.2955,
    x2: 1093.88,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1416.62,
    y1: -51.2955,
    x2: 1416.62,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.036,
    y1: -51.2955,
    x2: 287.036,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 932.512,
    y1: -51.2955,
    x2: 932.512,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 609.772,
    y1: -51.2955,
    x2: 609.772,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1255.25,
    y1: -51.2955,
    x2: 1255.25,
    y2: 1116.11,
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1175.08,
    y: 219.985,
    width: 80.2262,
    height: 79.0801,
    fill: "#1E2A5D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.69,
    y: 139.759,
    width: 80.2262,
    height: 79.0801,
    fill: "#3D3289",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093.71,
    y: 300.211,
    width: 80.2262,
    height: 79.0801,
    fill: "#1E2A5D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.318,
    y: 219.985,
    width: 80.2262,
    height: 79.0801,
    fill: "#3D3289",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093.71,
    y: 219.985,
    width: 80.2262,
    height: 79.0801,
    fill: "#1E2A5D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.318,
    y: 139.759,
    width: 80.2262,
    height: 79.0801,
    fill: "#3D3289",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1013.49,
    y: 58.3864,
    width: 80.2262,
    height: 80.2262,
    fill: "#3D3289",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 933.26,
    y: -33.3006,
    width: 80.2262,
    height: 80.2262,
    fill: "#3D3289",
    fillOpacity: 0.156863
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.382,
    y: 57.2404,
    width: 80.2262,
    height: 81.3723,
    fill: "#3D3289",
    fillOpacity: 0.156863
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.639,
    y: 137.467,
    width: 81.3723,
    height: 82.5184,
    fill: "#344BB1",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.267,
    y: 57.2404,
    width: 81.3723,
    height: 80.2262,
    fill: "#344BB1",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0409,
    y: 58.3864,
    width: 81.3723,
    height: 80.2262,
    fill: "#344BB1",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.267,
    y: 137.467,
    width: 81.3723,
    height: 82.5184,
    fill: "#344BB1",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.464,
    y: -22.9858,
    width: 81.3723,
    height: 80.2262,
    fill: "#3D3282",
    fillOpacity: 0.733333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.639,
    y: 299.065,
    width: 80.2262,
    height: 81.3723,
    fill: "#344BB1",
    fillOpacity: 0.24
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_105",
    x1: 219.586,
    y1: -6.54107,
    x2: 674.067,
    y2: 235.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8_105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.9135 614.111) rotate(-29.3932) scale(777.019 1335.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 424,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBannerGridDataAnalytics);
export default __webpack_public_path__ + "static/media/blueBannerGridDataAnalytics.8c212327267de1d190d78e526462b0fb.svg";
export { ForwardRef as ReactComponent };